import { PeriodicTaskBase } from '#common/util';
const MINUTE = 60 * 1_000;
const DEFAULT_STS_REFRESH_INTERVAL_MS = 10 * MINUTE;
export class StsCredentialsProvider extends PeriodicTaskBase {
    stsConfigFetcher;
    creds = {
        accessKey: '',
        secretKey: '',
        sessionToken: '',
        expiration: new Date(0),
    };
    constructor(stsConfigFetcher) {
        super('StsCredentialsProvider', DEFAULT_STS_REFRESH_INTERVAL_MS);
        this.stsConfigFetcher = stsConfigFetcher;
    }
    async setUp() {
        await this.fetchAndCache();
        const intervalMs = await this.stsConfigFetcher.fetchRefreshIntervalMs();
        this.start(intervalMs);
    }
    getCredentials() {
        return () => Promise.resolve({
            accessKeyId: this.creds.accessKey,
            secretAccessKey: this.creds.secretKey,
            sessionToken: this.creds.sessionToken,
            expiration: this.creds.expiration,
        });
    }
    async execute() {
        await this.fetchAndCache();
    }
    onError(_err) {
        this.log.warn('Failed to refresh STS credentials');
    }
    async fetchAndCache() {
        this.creds = await this.stsConfigFetcher.fetchStsConfig();
    }
}
